import * as React from "react";
import type { SVGProps } from "react";

interface CrashProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Crash = ({ cancelled = false, ...props }: CrashProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="m13.503.28 1.137 5.29.445 2.068 1.44-.788 4.903-2.683-2.005 5.217-.644 1.674h4.233l-2.91 2.857 3.334.785-4.348 2.565.363.456.152.19 4.409 5.53-6.683-2.315-2.168-.75-.77.931-1.877 2.267-1.476-2.545-.017-.029-1.564.817-4.21 2.198 1.117-3.964-4.65.677 3.07-4.002.077-.102-.975-.635-3.122-2.021 3.376-1.56.588-.273-.036-.07-.655-1.306-.209-.416-.044-.087-.072-.144-.023-.046-.046-.092-.126-.25-2.131-4.25 4.553 1.367.02.006.056.017.23.069.248.075.133.04.534.16 2.034.61.056.017 1.6-2.84z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="m13.186 2.373.72 3.354.656 3.052 2.323-1.27 3.11-1.702-1.272 3.308-1.036 2.693h3.491l-2.267 2.227-.304.299 2.84.669-2.787 1.643-.675.399-.023.012.027.033.876 1.099.151.19 2.796 3.507-4.238-1.468-2.659-.922-1.102 1.333-1.19 1.437-.936-1.614-.377-.649-2.2 1.15-2.67 1.393.817-2.899.142-.505-.106.016-.445.065-.077.011-.13.02-.033.004-.01.001-3.166.461 1.946-2.538.102-.133.049-.063.39-.508.033-.045-1.659-1.074-1.979-1.282 2.14-.99 1.29-.596-.005-.011-.809-1.612-.117-.234-.145-.288-.132-.264-.154-.306-.069-.139-.072-.144-.053-.105-1.352-2.695 2.888.867.019.006.057.017.113.034.116.034.915.275 1.085.326.218.065 1.219.366.143.043 1.894-3.364z"
      />
      <path
        fill="#FFE42B"
        d="m8.508 20 .686-2.432-2.784.405 1.43-1.866L5 14.267l2.508-1.159L5.35 8.805l4.882 1.465L12.636 6l1.022 4.756L17.51 8.65l-1.714 4.46H18l-1.986 1.95 1.986.468-1.986 1.171L18 19.19l-3.511-1.216L12.811 20l-1-1.724z"
      />
      <path
        fill="#FF1212"
        d="m12.636 6 .715 3.33-.557 4.17h-3.29l1.996 2.69-2.126 3.358-.866.452.686-2.432-2.784.405 1.43-1.866L5 14.267l2.508-1.159-.997-1.989-.202-.402-.182-.363-.238-.473-.54-1.076L9.334 10l.9.27z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Crash;
